import {
    BsChatSquareQuoteFill,
    BsFillBugFill,
    BsFillExclamationTriangleFill,
} from 'react-icons/bs'

const PopUp = ({setPopUpActive, message, action, type, cancel}) => {


    const runAction = () => {
        setPopUpActive(false)
        action()
    }

    const cancelAction = () => {
        setPopUpActive(false)
        if (cancel) cancel()
    }

    const IconSplitter = () => {
        switch(type) {
            case "confirm":
                return(<BsFillExclamationTriangleFill size={"4rem"}/>)
            case "message":
                return(<BsChatSquareQuoteFill size={"4rem"} />)
            case "error":
                return(<BsFillBugFill size={"4rem"} />)
        }
    }

    const ButtonTextSplitter = () => {
        switch(type) {
            case "confirm":
                return "Confirm"
            case "message":
                return "Okay"
            case "error":
                return "I will"
        }
    }

    return(
        <div className='pop-up-window' role="presentation" onClick={cancelAction}>
            <div className='pop-up-pane' role="dialog" aria-modal="true" onClick={(event) => event.stopPropagation()}>
                <div className='pop-up-icon'>
                    <IconSplitter />
                </div>
                <div className='pop-up-message'>
                    <div style={{fontSize:"1.2rem"}}>{message}</div>
                </div>
                <div className="pop-up-actions">
                    <button className='pop-up-button confirm' onClick={runAction}>
                        {ButtonTextSplitter()}
                    </button>
                    <button className="pop-up-button cancel" onClick={cancelAction}>
                        Cancel
                    </button>
                </div>

            </div>
        </div>
    )



}

export default PopUp
